import React, { useEffect } from 'react';
import { Translate } from '../WithTranslate';
import { ProgressionDialog, useProgressionDialogState } from './ProgressionsDialog';
import { TLCode } from '../../../common/enums';

interface MessagePreviewMailConfirmationProps {
  translate: Translate;
  inProgress: boolean;
  inError: boolean;
  done: boolean;
}

export const MessagePreviewMailConfirmation = ({
  translate,
  inProgress,
  inError,
  done,
}: MessagePreviewMailConfirmationProps) => {
  const progressionDialogState = useProgressionDialogState();

  const doneText = translate(TLCode.MESSAGE_Confirmation_Preview_Message);
  const errorText = translate(TLCode.MESSAGE_Confirmation_Preview_Error);
  const titleText = translate(TLCode.MESSAGE_Confirmation_Preview_Title);
  const closeButtonText = translate(TLCode.Close);

  useEffect(() => {
    if (inProgress) progressionDialogState.setInProgress();
  }, [inProgress, progressionDialogState.setInProgress]);

  useEffect(() => {
    if (inError) progressionDialogState.setInError();
  }, [inError, progressionDialogState.setInError]);

  useEffect(() => {
    if (done) progressionDialogState.setDone();
  }, [done, progressionDialogState.setDone]);

  return (
    <ProgressionDialog
      inProgress={progressionDialogState.inProgress}
      inError={progressionDialogState.inError}
      done={progressionDialogState.done}
      titleText={titleText}
      doneText={doneText}
      errorText={errorText}
      closeButtonText={closeButtonText}
      onClose={progressionDialogState.reset}
    />
  );
};
